export default "__VITE_ASSET__DGPiODeP__"